import {PluginsContainer} from './plugins-container';

export default {
    component: PluginsContainer
};
